const cFormEn = {
  attributeRenderer: {
    noAttributes: 'No attributes'
  },
  bankAccountItem: {
    accountHolderName: 'Account Holder Name',
    accountNumber: 'Account Number',
    accountType: {
      CHECKING: 'Checking',
      ORDINARY: 'Ordinary',
      SAVINGS: 'Savings',
      label: 'Account Type'
    },
    bankCode: 'Bank Code',
    bankName: 'Bank Name',
    branchCode: 'Branch Code',
    branchName: 'Branch Name'
  },
  birthdayItem: {
    age: '{{count}} years old'
  },
  commuteRouteItem: {
    addFare: 'Add fare',
    addMethod: 'Add method',
    commutingMethod: {
      BIKE: 'Bicycle',
      BUS: 'Bus',
      CAR: 'Car',
      COMPANY_BUS: 'Company Bus',
      TRAIN: 'Train',
      WALK: 'Walk',
      label: 'Commuting Method'
    },
    currency: {
      CNY: 'CNY',
      IDR: 'IDR',
      JPY: 'JPY',
      THB: 'THB',
      USD: 'USD',
      VND: 'VND',
      label: 'Currency'
    },
    distance: 'Distance',
    distanceUnit: 'km',
    duration: 'Duration',
    durationUnit: 'min',
    fare: 'Fare',
    fareType: {
      HALF_YEARLY: 'Semi-annual',
      MONTHLY: 'Monthly',
      ONE_WAY: 'One-way',
      QUARTERLY: 'Quarterly'
    },
    route: 'Route',
    routeDetail: 'Route Detail',
    select: 'Select'
  },
  country: {
    loadFailed: 'Failed to load country data',
    loading: 'Loading country data...'
  },
  deviceCatalogSelectItem: {
    label: 'Device catalog'
  },
  employeeSubIdItem: {
    addEmployeeSubIdName: 'Add employee sub ID name',
    employeeSubId: 'Sub ID',
    employeeSubIdName: 'Sub ID Name',
    unregistered: 'Unregistered'
  },
  familyPersonalInfoItem: {
    familyMember: 'Family member',
    firstName: 'First Name',
    lastName: 'Last Name',
    middleName: 'Middle Name',
    relationship: 'Relationship',
    viewProfile: 'View profile'
  },
  fileItem: {
    maxFileSize: 'Max {{size}}MB per file',
    maxFiles: 'Max {{count}} files',
    supportedFormats: 'Supported formats: {{formats}}'
  },
  hometownItem: {
    additionalAreaInfo: 'Additional Area Info',
    city: 'City',
    country: 'Country',
    detailInformation: 'Detail Information',
    durationFrom: 'From',
    durationTo: 'To',
    hometown: 'Hometown',
    postalCode: 'Postal Code',
    stateProvince: 'State / Province'
  },
  leaveOfAbsenceItem: {
    endDate: 'End Date',
    kind: 'Type',
    startDate: 'Start Date'
  },
  masterData: {
    loadFailed: 'Failed to load data'
  },
  phoneItem: {
    phoneType: {
      LANDLINE: 'Landline',
      MOBILE: 'Mobile',
      label: 'Phone type'
    }
  },
  sectionDetailLayout: {
    emptyDescription: 'There is no information to display. You may not have permission to view this category.',
    emptyTitle: 'No information available',
    errorTitle: 'Failed to load data'
  },
  snsAccountItem: {
    accountId: 'Account ID',
    snsType: {
      Facebook: 'Facebook',
      Instagram: 'Instagram',
      Line: 'LINE',
      Twitter: 'X (Twitter)',
      label: 'SNS Type'
    },
    url: 'URL'
  },
  workLocationItem: {
    details: 'Details'
  }
};
export default cFormEn;